"use strict";

require("core-js/modules/es6.array.map");
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.object.define-property");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var $ = require("jquery");
exports.StrongPasswordRule = function () {
  $.validator.addMethod("strong", function (value, element, errListId) {
    var errors = [];
    var errListContainer = $(errListId);
    var uppercaseCheck = /[A-Z]/;
    var lowercaseCheck = /[a-z]/;
    var specialCheck = /[!@#$%^&*()\-_=+\[\]{};:,<.>?'"\/~|`]/;
    var numbersCheck = /[0-9]/;
    value.length < 6 && errors.push("przynajmniej 6 znaków");
    !uppercaseCheck.test(value) && errors.push("duże litery");
    !lowercaseCheck.test(value) && errors.push("małe litery");
    !specialCheck.test(value) && errors.push("znaki specjalne");
    !numbersCheck.test(value) && errors.push("liczby");
    if (errListContainer.length == 0) {
      errListContainer = $('<lu>', {
        id: errListId.replace('#', '')
      });
      $(element).after(errListContainer);
    }
    errListContainer.empty();
    if (errors.length > 0) {
      errListContainer.show();
      errListContainer.append("<p>Has\u0142o powinno zawiera\u0107:</p>");
      errors.map(function (err) {
        errListContainer.append("<li>" + err + "</li>");
      });
      return false;
    }
    errListContainer.hide();
    return true;
  }, "Hasło nie spełnia wymagań");
}();